import { SubscriptionApi } from '../api/SubscriptionApi'
import { subscriptionStore } from '../store/subscriptionStore'
import { Order } from '../core/Order'
import { scrollToTop } from '../assets/js/main'

export const subscription = {
	methods: {
		$_subscription_catchError (response) {
		},

		$_subscription_beforeAction () {
		},

		$_subscription_afterAction () {
		},

		$_subscription_calendar (weekPlan, action) {
			this.$_subscription_beforeAction()

			var params = {
				week_plan_id: weekPlan.id,
				action: action
			}

			return subscriptionStore.updateCalendar({
				subscription: this.user.subscription,
				params: params
			})

			.then(response => {
				this.$_subscription_updateUserView(response)
				this.$_subscription_afterAction()
				if (params.action === 'skip') {
					this.openTypeform()
				}
			})

			.catch(response => {
				this.$_subscription_catchError(response)
			})
		},

		$_subscription_suspend () {
			this.$_subscription_beforeAction()
			var sm = new SubscriptionApi()
			return sm.suspend(this.user.subscription)

			.then(response => {
				this.$_subscription_updateUserView(response)
				this.$_subscription_afterAction()
				// scrollToTop()
			})

			.catch(response => {
				this.$_subscription_catchError(response)
			})
		},

		$_subscription_suspendAfter (action) {
			this.$_subscription_beforeAction()

			var params = {}
			params.suspend_after_checkout = action === 'on' ? 1 : 0
			var sm = new SubscriptionApi()
			return sm.update(this.user.subscription, params)

			.then(response => {
				this.$_subscription_updateUserView(response)
				this.$_subscription_afterAction()
				// scrollToTop()
			})

			.catch(response => {
				this.$_subscription_catchError(response)
			})
		},

		$_subscription_updateUserView (response) {
			var user = this.user
			var subscription = {
				...user.subscription,
				...response.body.data.resource
			}
			user.subscription = subscription

			var order = {
				...user.order ? user.order : null,
				...response.body.data.resource.calendar[0] ? response.body.data.resource.calendar[0].order : null
			}

			user.order = order.id ? new Order(order) : null

			this.$root.updateUser(user)
		},

		$_subscription_resume () {
			this.$_subscription_beforeAction()
			var sm = new SubscriptionApi()
			return sm.resume(this.user.subscription)

			.then(response => {
				this.$_subscription_updateUserView(response)
				this.$_subscription_afterAction()
				scrollToTop()
			})

			.catch(response => {
				this.$_subscription_catchError(response)
			})
		}
	}
}
